import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { News } from "./../../models/cms/news-list";
import { LanguageService } from './language.service';


@Injectable()
export class ArticleService {
  constructor
    (
    public _api: ApiService,
    public _cache: CacheService,
    private mappings: Mappings,
    private languageService: LanguageService
    ) { }

  getArticleList(category: string, listtype: string) {
    let lang = this.languageService.getLongLang();

    let url = this.mappings.Web_Api_Get_Article_List.replace('{category}', category).replace('{listtype}', listtype).replace('{lang}', lang);
    let key = url;

    return this._api.get(url);
  }

  getArticleDetails(id: number, lang: string) {
    let url = this.mappings.Web_Api_Get_News_Details.replace('{lang}', lang).replace('{id}', id.toString());
    let key = url;

    return this._api.get(url);
  }

  getArticleByUrl(lang: string, seoUrl: string) {
    let url = this.mappings.Web_Api_Get_Article_By_Url.replace('{lang}', lang).replace('{seoUrl}', seoUrl);
    let key = url;

    return this._api.get(url)
  }

  GetArticleByCategoryIdandRows(categoryId: number, lang: string, startRowIndex: number, maxRows: number) {
    let url = this.mappings.Web_Api_Get_Article_By_Category_Id.replace('{categoryId}', categoryId.toString()).replace('{lang}', lang).replace('{startRowIndex}', startRowIndex.toString()).replace('{maxRows}', maxRows.toString());
    let key = url;

    return this._api.get(url);
  }

  getBlogData(lang: string, startRowIndex: number, maxRows: number) {
    let numberOfItems: number = 15;

    let url = this.mappings.Web_Api_Get_Blog_Data.replace('{lang}', lang).replace('{startRowIndex}', startRowIndex.toString()).replace('{maxRows}', maxRows.toString());
    let key = url;
    return this._api.get(url);
  }

  getArticleListCategory(lang: string) {
    let url = this.mappings.Web_Api_Get_Article_List_Category.replace('{lang}', lang);
    let key = url;

    return this._api.get(url);
  }

  getCategoryArticleById(categoryId: string, lang: string, startRowIndex: number, maxRows: number) {
    let url = this.mappings.Web_Api_Get_Article_Category_By_Id
      .replace('{categoryId}', categoryId)
      .replace('{lang}', lang)
      .replace('{startRowIndex}', startRowIndex.toString())
      .replace('{maxRows}', maxRows.toString());
    let key = url;

    return this._api.get(url);
  }

  getArticleCategoryByUrl(lang: string, categoryUrl: string, startRowIndex: number, maxRows: number) {
    let url = this.mappings.Web_Api_Get_Article_Category_By_Url
      .replace('{lang}', lang)
      .replace('{startRowIndex}', startRowIndex.toString())
      .replace('{maxRows}', maxRows.toString())
      .replace('{categoryUrl}', categoryUrl);
    let key = url;

    return this._api.get(url)
  }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/article.service.ts